import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// App
import App from "@/App";
import ProtectedRoute from "@/components/global/ProtectedRoute";
import SuperuserRoute from "./components/global/SuperuserRouter";
// Pages
// const Dashboard = lazy(() => import("@/pages/Dashboard"));

// // Login
const LoginPage = lazy(() => import("@/pages/Login"));

// Misc
const NotFound = lazy(() => import("@/pages/NotFound"));
const Terms = lazy(() => import("@/pages/Terms"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Overview = lazy(() => import("@/pages/Overview"))
const HygienePage = lazy(() => import("@/pages/Hygiene"))
const MarketingMixPage = lazy(() => import("@/pages/MarketingMix"))
const FeatureAdoptionPage = lazy(()=> import("@/pages/FeatureAdoption"))
const InstanceSetupPage = lazy(()=> import("@/pages/InstanceSetup")) 

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    children: [
      { path: "/", element: <Overview /> },
      { path: "/hygiene", element: <HygienePage /> },
      { path: "/marketing-mix", element: <MarketingMixPage /> },
      { path: "/feature-adoption", element: <FeatureAdoptionPage /> },

      {
        element: <SuperuserRoute />,
        children: [
          { path: "/instance-setup", element: <InstanceSetupPage /> },
          { path: "/user-edit", element: <div>User Edit Page</div> }, // add your page later
        ],
      },

      { path: "*", element: <NotFound /> }, 
    ],
  },

  { path: "login", element: <LoginPage /> },
  { path: "terms", element: <Terms /> },
  { path: "privacy", element: <Privacy /> },
]);

const AppRouter: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default AppRouter;
